import React from 'react';
import { FINANCIAL_PILLS, FULFILLMENT_PILLS, humanizeStatus } from './statusPillMaps';

/**
 * Status pills for a placed order.
 *
 * Deliberately separate from DraftOrderStatusPills: quotes and orders have
 * different status vocabularies. Pill classes are shared via statusPillMaps.
 */

function lookupPill(map, status) {
  if (!status) return null;
  return map[status] || { label: humanizeStatus(status), className: 'pill-button-grey' };
}

function resolvePills(order) {
  if (order.cancelledAt) {
    return [{ label: 'Cancelled', className: 'pill-button-expired' }];
  }

  const financial = (order.displayFinancialStatus || '').toLowerCase();
  const fulfillment = (order.displayFulfillmentStatus || '').toLowerCase();
  const isGovPO = !!order.governmentPo;
  const hasPOFile = !!order.governmentPoDocument;
  const poSent = order.poSent;
  const isFulfilled = fulfillment === 'fulfilled';
  const isPartiallyFulfilled = fulfillment === 'partially_fulfilled';
  const pills = [];

  if (isGovPO && !hasPOFile) {
    pills.push({ label: 'Awaiting Purchase Order', className: 'pill-button-red' });
  } else if (isGovPO && !poSent && hasPOFile && fulfillment === 'unfulfilled') {
    pills.push({ label: 'PO Under Review', className: 'pill-button-grey' });
  } else if (isGovPO && poSent && hasPOFile && fulfillment === 'unfulfilled') {
    pills.push({ label: 'PO Accepted', className: 'pill-button-grey' });
    pills.push({ label: 'Processing Order', className: 'pill-button-yellow' });
  } else if (isGovPO && isFulfilled && financial === 'pending') {
    pills.push({ label: 'Payment Due', className: 'pill-button-red' });
  } else if (isGovPO && isPartiallyFulfilled && financial === 'pending') {
    pills.push({ label: 'Payment Due', className: 'pill-button-orange' });
  } else {
    const financialPill = lookupPill(FINANCIAL_PILLS, financial);
    if (financialPill) pills.push(financialPill);
  }

  const hideFulfillment = financial === 'pending' && fulfillment === 'unfulfilled';
  if (!hideFulfillment) {
    const fulfillmentPill = lookupPill(FULFILLMENT_PILLS, fulfillment);
    if (fulfillmentPill) pills.push(fulfillmentPill);
  }

  if (order.taxExempt) {
    pills.push({ label: 'Tax Exempt', className: 'pill-button-tax-exempt' });
  }

  return pills;
}

function OrderStatusPills({ order, className = '' }) {
  if (!order) return null;

  const pills = resolvePills(order);
  if (!pills.length) return null;

  return (
    <div className={`draft-order-status-container ${className}`}>
      {pills.map((pill) => (
        <span
          key={pill.label}
          className={`pill-button draft-order-status ${pill.className}`}
        >
          {pill.label}
        </span>
      ))}
    </div>
  );
}

export default OrderStatusPills;
